import { APICore } from "./apiCore";

const api = new APICore();

const listarCidades = (query: string) => {
    return api.get(`/cidade?${query}`);
};

export { listarCidades };
